import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { SiilaTranslationService } from "../../core/services/siila-translation.service";
import { I18nService } from "./i18n.service";

/** localStorage key with how many news the REsource home list had loaded. */
export const NEWS_LOADED_COUNT_KEY = "newsLoadedCount";
/** localStorage key with the id of the news the reader opened from that list. */
export const NEWS_LAST_CLICKED_KEY = "newsLastClickedId";

@Injectable()
export class NewsNavigateService {
  currentCode = environment.platformId;
  constructor(
    private router: Router,
    private siilaTranslationService: SiilaTranslationService,
    private i18: I18nService
  ) {}

  openNews(
    id: number,
    title,
    isMobile,
    pageSize,
    isIOS,
    browserLang,
    condition = false,
    latamCountry?
  ) {
    this.rememberListScroll(isMobile, pageSize);

    if (isIOS) {
      this.router.navigateByUrl(this.addUrl(browserLang, title, id));
    } else {
      if (condition) {
        window.open(
          `${
            this.currentCode == "co"
              ? latamCountry == "latamBr"
                ? environment.applicationURLBr + "/"
                : environment.applicationURLMx + "/"
              : ""
          }${this.addUrl(browserLang, title, id)}`,
          isMobile ? "_self" : "_blank"
        );
      } else {
        window.open(
          this.addUrl(browserLang, title, id),
          isMobile ? "_self" : "_blank"
        );
      }
    }
  }

  /**
   * On mobile, save the list's scroll position, how many news were loaded and
   * which news was opened, so the REsource home can restore them when the
   * reader comes back from an article.
   */
  rememberListScroll(
    isMobile: boolean,
    loadedCount: number | string,
    newsId?: number
  ): void {
    if (isMobile) {
      localStorage.setItem("scrollPosition", window.pageYOffset.toString());
      localStorage.setItem(NEWS_LOADED_COUNT_KEY, loadedCount.toString());
      if (newsId) {
        localStorage.setItem(NEWS_LAST_CLICKED_KEY, newsId.toString());
      } else {
        localStorage.removeItem(NEWS_LAST_CLICKED_KEY);
      }
    }
  }

  addUrl(browserLang, title, id) {
    const sts = this.siilaTranslationService;
    const basePath = `${sts.getNewsSlugPrefix(browserLang)}/${sts.slugify(
      sts.getTranslation(title)
    )}/${id}`;
    return sts.buildLocalizedPath(basePath);
  }

  /**
   * Root-relative router path to a news detail (`/news/<slug>/<id>[/lang/xx]`),
   * for `[routerLink]` on REsource cards. Same URL `openNews` navigates to, with
   * a guaranteed leading `/` so it never resolves relative to the current page
   * (on an article page a relative `news/...` would nest under it). Pure string
   * op — SSR-safe, so the href is present in the prerendered markup.
   */
  buildNewsRoute(id: number, title: string, browserLang: string): string {
    return "/" + this.addUrl(browserLang, title, id).replace(/^\/+/, "");
  }

  openNewsSearch(isMobile, keyword) {
    const encodedKeyword = encodeURIComponent(keyword);
    window.open(
      this.siilaTranslationService.buildLocalizedPath(
        `search_news?keyword=${encodedKeyword}`
      ),
      isMobile ? "_self" : "_blank"
    );
  }

  goNewsTags(tag, color, stateName, isMobile) {
    const basePath = `resource/tags/${this.siilaTranslationService.getTranslation(
      stateName
    )}/${tag.id}/${color}`;
    window.open(
      this.siilaTranslationService.buildLocalizedPath(basePath),
      isMobile ? "_self" : "_blank"
    );
  }

  goHome(latam = false, isMobile?) {
    window.open(
      latam
        ? this.siilaTranslationService.buildCrossCountryUrl(
            "latam",
            "/resource"
          )
        : this.siilaTranslationService.buildLocalizedPath("resource"),
      isMobile ? "_self" : "_blank"
    );
  }
}
